<template> 
  <b-navbar id="navbar" type="dark" toggleable='md'>
    <b-navbar-brand href="#" class="d-block d-sm-none pl-2">MENU</b-navbar-brand>
    <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_dropdown_collapse">
      <b-navbar-nav>
        <template v-for="(item, key) in navitems">
          <template v-if="item.children">
            <b-nav-item-dropdown :text="item.name" :href="item.url ? item.url : '#'" :key="'navitem_'+key" :target="item.url_ext ? '_blank' : null">
                <b-dropdown-item v-for="(subitem, subkey) in item.children" :key="'navitem_'+key+'_subitem_'+subkey" :href="subitem.url ? subitem.url : '#'" :target="subitem.url_ext ? '_blank' : null">
                  {{ subitem.name }}
                </b-dropdown-item>
            </b-nav-item-dropdown>
          </template>
          <template v-else>
            <b-nav-item :href="item.url ? item.url : '#'" :key="'navitem_'+key" :target="item.url_ext ? '_blank' : null">
              {{ item.name }}
            </b-nav-item>
          </template>
        </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>


<script>
export default {
  name: 'Navbar',
  props: {
    'navitems' : {
      type: Array
    }
  },
  data:()=>{
    return {
      
    }
  },
  method:{

  }
}
</script>


<style scoped> 
   
</style>



// WEBPACK FOOTER //
// src/components/overall_layouts/navbar.vue